module.exports = __webpack_public_path__ + "static/media/tree.ca5f7b22.png";